import { useRef } from 'react';
import { sameStringArray } from '../utils/sameStringArray';

// Keeps the same array reference while its contents don't change.
// Without it we'd hand Ionic a new (but equal) value array on every render, which makes it re-sync
// and collapse a mid-animation accordion.
export const useStableStringArray = (next: string[]): string[] => {
  const ref = useRef<string[]>(next);
  if (!sameStringArray(ref.current, next)) {
    ref.current = next;
  }
  return ref.current;
};
